export default __webpack_public_path__ + "static/media/cloud-1.e508fe78.png";